import React, { useEffect, useState } from "react";
import { Row, Col, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export default function TextField({
  label = "Label Not Set",
  initialValue = "",
  onChange,
  disabled = false,
  placeholder = "Enter text",
  showTooltip = false,
  tooltipMessage = ""
}) {
    const [text, setText] = useState(initialValue);

    const handleChange = (e) => {
        setText(e.target.value);
        onChange && onChange(e.target.value);
    };

    // If initialValue changes from parent, rerender
    useEffect(() => {
        setText(initialValue);
    }, [initialValue]);

    return (
        <Row gutter={[8, 8]} style={{ marginTop: "20px", width: "100%" }}>
            <Col span={24}>
                <h3 style={{ marginBottom: 0, fontWeight: "bold", display: "flex", alignItems: "center", gap: "6px" }}>
                    {label}
                    {showTooltip && (
                      <Tooltip title={tooltipMessage}>
                        <InfoCircleOutlined />
                      </Tooltip>
                    )}
                </h3>
            </Col>
            <Col span={24}>
                <Input
                    value={text}
                    onChange={handleChange}
                    disabled={disabled} 
                    placeholder={placeholder}
                    style={{ textAlign: "left" }}
                />
            </Col>
        </Row>
    );
}
